import { createClient } from '@supabase/supabase-js';
import { fetchWithTimeout } from './async';

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim()
  || import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

export const isSupabaseConfigured = Boolean(url && publishableKey && !url.includes('YOUR_PROJECT'));
export const supabase = isSupabaseConfigured ? createClient(url, publishableKey, {
  global: { fetch: fetchWithTimeout },
}) : null;
